import React from 'react';

import CheckboxInput from 'components/CheckboxInput';
import useSameInstructorToggle from '../useSameInstructorToggle';

function SameSecondaryInstructorToggle() {
  const { areAllInstructorsSame, onToggle } = useSameInstructorToggle(
    'secondaryInstructor'
  );

  return (
    <CheckboxInput
      checked={areAllInstructorsSame}
      className="full-width"
      onChange={onToggle}
    >
      Same for all
    </CheckboxInput>
  );
}

export default SameSecondaryInstructorToggle;
